import en from "@/localization/en.json";
import { PropTypes } from "prop-types";
import { useState } from "react";
import OtpInput from "react18-input-otp";
import CountDown from "../countdown";

import Styles from "./otp.module.css";

export default function Otp({
  phoneNumber,
  onOtpSubmit,
  onPhoneNumberChangeRequest,
  onResendOtpRequest,
}) {
  const [otp, setOtp] = useState("");
  const [isTimeCompleted, setIsTimeCompleted] = useState(false);

  const handleChange = (enteredOtp) => {
    setOtp(enteredOtp);
    if (enteredOtp.length < 6 || isTimeCompleted) return;
    onOtpSubmit(enteredOtp);
  };

  const resendOtpRequest = () => {
    setIsTimeCompleted(false);
    onResendOtpRequest();
  };

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-[#0A101A] text-[1.75rem] font-semibold text-center mb-[1.875rem]">
        {en["resetPassword.otp"]}
      </h3>
      <p className="text-[#414E5F] text-center">
        {en["resetPassword.type_6_digit_code"]}
      </p>
      <p className="text-[#0A101A] font-semibold text-center mb-[1.875rem]">
        {phoneNumber}
      </p>

      <OtpInput
        isInputNum
        numInputs={6}
        separator={" "}
        inputStyle={`${Styles.singleInput}`}
        placeholder={"------"}
        value={otp}
        shouldAutoFocus
        onChange={handleChange}
      />

      <div className="mt-[1.875rem]">
        <CountDown
          onResendOtpRequest={resendOtpRequest}
          onTimerComplete={() => setIsTimeCompleted(true)}
        />
      </div>

      <p
        className="text-center text-[#1F2A3B] underline cursor-pointer mt-[1.875rem]"
        onClick={onPhoneNumberChangeRequest}
      >
        {en["common.change_phone_number"]}
      </p>
    </div>
  );
}

Otp.propTypes = {
  phoneNumber: PropTypes.string,
};
